import React, { useState } from 'react'
import { CBadge, CSmartTable } from '@coreui/react-pro'
import moment from 'moment'
import ToastComponent from 'src/components/common/TaostComponent.js'
import RowActionsMenu from 'src/components/common/RowActionsMenu'
import TeamAlertService from 'src/service/TeamAlertService'
import Notify from '../Notify'

const columns = [
  { key: 'title', label: 'Alert', filter: false, sorter: true },
  { key: 'is_sent', label: 'Status', filter: false, sorter: false, _style: { width: '16%' } },
  { key: 'created_at', label: 'Created', filter: false, sorter: true, _style: { width: '16%' } },
  { key: 'actions', label: 'Actions', filter: false, sorter: false, _style: { width: '1%' } },
]

const CONFIRM_TEXT = {
  delete: 'Are you sure you want to delete this alert?',
  send: 'Send this alert now? Every active member gets a push notification immediately, and it can only be sent once.',
}

const Table = ({
  users,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnSorter,
  itemsPerPage,
  activePage,
  columnSorter,
  loading,
  onEditAlert,
}) => {
  const [actionLoading, setActionLoading] = useState(false)
  const [confirmAction, setConfirmAction] = useState(null) // { type: 'delete' | 'send', id }

  const deleteAlert = (id) => {
    setActionLoading(true)
    TeamAlertService.deleteTeamAlert({ id })
      .then((res) => {
        if (res.status === 200) {
          fetchUsers()
          ToastComponent(res.message, 'success')
        } else {
          ToastComponent(res.message, 'error')
        }
      })
      .finally(() => setActionLoading(false))
  }

  const sendAlert = (id) => {
    setActionLoading(true)
    TeamAlertService.sendTeamAlert(id, 1)
      .then((res) => {
        if (res.status === 200) {
          fetchUsers()
          ToastComponent(res.message, 'success')
        } else {
          ToastComponent(res.message, 'error')
        }
      })
      .finally(() => setActionLoading(false))
  }

  const handleCancel = () => setConfirmAction(null)
  const handleConfirm = () => {
    if (confirmAction?.type === 'send') sendAlert(confirmAction.id)
    if (confirmAction?.type === 'delete') deleteAlert(confirmAction.id)
    setConfirmAction(null)
  }

  const totalPages = Math.ceil((users?.total || 0) / itemsPerPage)

  return (
    <div className="ge-datatable ge-datatable--no-select">
      <CSmartTable
        columns={columns}
        columnSorter={{ external: true }}
        sorterValue={columnSorter}
        noItemsLabel="No alerts yet"
        scopedColumns={{
          title: (item) => (
            <td>
              <div className="d-flex flex-column gap-1">
                <span
                  className="fw-semibold text-primary"
                  role="button"
                  onClick={() => onEditAlert(item.id)}
                >
                  {item.title}
                </span>
                {item.short_description && (
                  <span className="ta-alert-preview">{item.short_description}</span>
                )}
              </div>
            </td>
          ),
          is_sent: (item) => (
            <td>
              <CBadge
                color={item.is_sent === 1 ? 'success' : 'warning'}
                shape="rounded-pill"
                className="px-2 py-1"
              >
                {item.is_sent === 1 ? 'Sent' : 'Pending'}
              </CBadge>
            </td>
          ),
          created_at: (item) => (
            <td>{item.created_at ? moment(item.created_at).format('D.MM.YYYY') : '-'}</td>
          ),
          actions: (item) => (
            <td>
              <RowActionsMenu
                actions={[
                  { label: 'Edit', onClick: () => onEditAlert(item.id) },
                  {
                    label: item.is_sent === 1 ? 'Sent' : 'Send',
                    disabled: actionLoading || item.is_sent === 1,
                    onClick: () => setConfirmAction({ type: 'send', id: item.id }),
                  },
                  {
                    label: 'Delete',
                    danger: true,
                    disabled: actionLoading,
                    onClick: () => setConfirmAction({ type: 'delete', id: item.id }),
                  },
                ]}
              />
            </td>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading || actionLoading}
        pagination={{ external: true }}
        paginationProps={{
          activePage,
          pages: totalPages || 1,
        }}
        tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
        onActivePageChange={(page) => setActivePage(page)}
        onItemsPerPageChange={(perPage) => {
          setActivePage(1)
          setItemsPerPage(perPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        showConfirm={!!confirmAction}
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        text={confirmAction ? CONFIRM_TEXT[confirmAction.type] : ''}
      />
    </div>
  )
}

export default Table
